const brandConstants = {
	FETCH_BRANDS_REQUEST: 'FETCH_BRANDS_REQUEST',
	FETCH_BRANDS_SUCCESS: 'FETCH_BRANDS_SUCCESS',
	FETCH_BRANDS_FAILURE: 'FETCH_BRANDS_FAILURE',
};

export default brandConstants;
